import { useRef, type FC } from 'react';
import ReactPlayer from 'react-player';
import { resolveMediaUrl } from '../api/client';
import { HlsVideo } from './HlsVideo';
import { BunnyVideo } from './BunnyVideo';
import { VideoUnavailable } from './VideoUnavailable';

const VIDEO_STYLE: React.CSSProperties = {
  width: '100%',
  height: 210,
  background: '#000',
  borderRadius: 'var(--radius-md)',
};

/**
 * Tahlil videosi — sahifaning OʻZIDA, dars videosi kabi.
 *
 * NEGA HAVOLA EMAS: ilgari bu `<a target="_blank" rel="noreferrer">`
 * edi va ishlamasdi, ikki sabab bilan birdaniga:
 *
 *  1. Bunny videosi uchun server `.m3u8` oqim srcini beradi. Uni
 *     Chrome oʻzi ijro eta olmaydi — hls.js kerak, u esa faqat
 *     bizning sahifamizda bor.
 *  2. Bunny kutubxonasi CDN'ga kirishni REFERRER boʻyicha toʻsadi
 *     (CLAUDE.md §3.6): referrer yoʻq -> 403. `noreferrer` aynan uni
 *     olib tashlardi.
 *
 * Telegram ichida yangi oyna ochish ham ishonchsiz. Shuning uchun
 * manba turi dars ekranidagi bilan BIR XIL aniqlanadi; farqi — bu
 * yerda koʻrish foizi hisoblanmaydi (tahlil videosi talab emas).
 */
export const AnalysisVideo: FC<{
  url: string | null | undefined;
  /** Video Bunny'da, Bunny esa hozir ishlamayapti. */
  unavailable?: boolean;
}> = ({ url, unavailable }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const src = resolveMediaUrl(url);
  if (!src) return unavailable ? <VideoUnavailable /> : null;

  if (src.includes('.m3u8')) {
    return <HlsVideo src={src} videoRef={videoRef} style={VIDEO_STYLE} />;
  }
  if (src.includes('mediadelivery.net')) {
    return <BunnyVideo src={src} />;
  }
  if (src.startsWith('/') || src.toLowerCase().endsWith('.mp4')) {
    return (
      <video
        src={src}
        controls
        playsInline
        controlsList="nodownload"
        style={VIDEO_STYLE}
      />
    );
  }
  return (
    <ReactPlayer src={src} controls width="100%" height="210px" playsInline />
  );
};
